import { propOr } from 'ramda'

export const buffer = propOr([], 'buffer')
